export default "__VITE_ASSET__a5ffe082__"